import React from 'react';


const ConfigContext = React.createContext({
  config: {},
});




export const AppContextProvider = ({ children, initValue }) => {

  // for global loader
  const [isLoading, setLoading] = React.useState(false);

  const handleLoader = (val) => {

    if (val !== undefined) {
      setLoading(val);
    } else {
      setLoading(!isLoading);
    }
  };

  return <ConfigContext.Provider value={{
    ...initValue,
    handleLoader: handleLoader,
    isLoading,
    config: {}
  }}>{children}</ConfigContext.Provider>;
};

export default ConfigContext;

export const useAppContext = () => {
  const context = React.useContext(ConfigContext);
  if (!context) {
    throw new Error("useAppContext within provider");
  }
  return context;
};
